export default __webpack_public_path__ + "static/media/produk 4.5c7d1a9d.png";